import { useContext } from 'react'
import { PlanContext, type PlanContextValue } from './PlanProvider'

export function usePlan(): PlanContextValue {
  const c = useContext(PlanContext)
  if (!c) throw new Error('usePlan must be used within PlanProvider')
  return c
}
